import {
  IncidentQueueTimeoutError,
  type ConfirmQueueIncident,
  type QueueIncident,
} from '../types.js'

function validateQueueIndex(queue: QueueIncident[], index: number): void {
  if (index < 0 || index >= queue.length) {
    throw Error(`index = ${index} is out of bounds`)
  }
}

export function enqueue(
  queueIncident: QueueIncident,
  queue: QueueIncident[],
): void {
  queue.push(queueIncident)
}

export function dequeue(queue: QueueIncident[], index: number): QueueIncident {
  validateQueueIndex(queue, index)

  return queue.splice(index, 1)[0]
}

export function peek(queue: QueueIncident[], index: number): QueueIncident {
  validateQueueIndex(queue, index)

  return queue[index]
}

export function confirmProcessedQueueIncident(
  uuid: string,
  confirmQueueIncident: ConfirmQueueIncident,
): Promise<void> {
  const timeout = 10000

  return new Promise((_resolve, _reject) => {
    const timeoutId = setTimeout(() => {
      _reject(
        new IncidentQueueTimeoutError(
          `Incident with uuid = ${uuid} was processed by API, but acknowledgment message wasn't received within ${
            timeout / 1000
          } seconds.`,
        ),
      )
    }, timeout)

    function resolve(): void {
      clearTimeout(timeoutId)
      _resolve()
    }

    function reject(error: Error): void {
      clearTimeout(timeoutId)
      _reject(error)
    }

    confirmQueueIncident(uuid, resolve, reject)
  })
}
